import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { QueryKey, STALE_TIME_VERY_LONG } from "@/constants/shared";
import { makeRequest } from "@/network/api";
import { App } from "@/types";

/**
 * Hook to fetch all apps from the API.
 * @returns An object containing the apps and loading state
 */
export const useApps = () => {
  const queryKey = [QueryKey.AllApps];

  const queryOptions: UseQueryOptions<App[]> = {
    queryKey,
    queryFn: async (): Promise<App[]> => {
      const response = await makeRequest("apps");
      const responseJson = await response.json();
      return responseJson.data.apps;
    },
    staleTime: STALE_TIME_VERY_LONG,
    refetchOnMount: false,
  };

  const { data: apps = [], isLoading } = useQuery(queryOptions);

  return {
    apps,
    isLoadingApps: isLoading,
  };
};
